module.exports = __webpack_public_path__ + "img/THETA.6d180d49.svg";